@import "~@govbr-ds/core/src/components/input/input";

:host {
  display: inline-block;
  width: 100%;

  .br-input .input-icon {
    margin: 0 var(--spacing-scale-2x);
  }

  .br-input .input-icon + input {
    padding-left: var(--spacing-scale-6x);
  }
}

.br-input {
  br-button {
    float: right;
    margin-right: var(--input-button-margin);
    margin-top: calc((var(--input-size) + var(--spacing-scale-half)) * -1);
    padding: 0;
    position: relative;

    &.button-transform {
      transform: translateY(calc((var(--input-size) - 32px) * 0.5));
    }
  }

  .input-label {
    margin-top: 0 !important;
  }

  &.input-inline {
    display: flex;
    align-items: center;
  }
}

/* Estilo borderless para composições contextuais */
:host([borderless]) {
  .br-input input {
    border-color: transparent;
  }

  .br-input input:focus,
  .br-input input:focus-visible {
    border-color: var(--border-color-alternative);
  }
}

::slotted([slot="feedback"]) {
  display: none;
}

::slotted(br-message[hidden]) {
  display: none !important;
}

:host([state]) ::slotted([slot="feedback"]) {
  display: block;
}
